const logos = [
    "Halcyon",
    "Northwind",
    "Maison Verre",
    "Atlas",
    "Polar",
    "Kore",
    "Outlier",
    "Verto",
];

export default function DigtekLogoStrip() {
    return (
        <section
            data-testid="digtek-logo-strip"
            className="relative py-12 bg-white border-y border-digtek-border overflow-hidden"
        >
            <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
                <div className="flex items-center gap-6 lg:gap-10 mb-6">
                    <div className="w-14 h-14 rounded-full bg-digtek-lime flex items-center justify-center shrink-0">
                        <span className="font-display font-bold text-digtek-header text-lg">
                            1K+
                        </span>
                    </div>
                    <h3 className="font-display font-bold text-2xl text-digtek-header">
                        Brands trust us
                    </h3>
                    <div className="hidden md:block flex-1 h-px bg-digtek-border" />
                </div>
                <div className="overflow-hidden">
                    <div className="flex items-center gap-16 animate-marquee-fast">
                        {[...logos, ...logos].map((l, i) => (
                            <span
                                key={i}
                                className="font-display font-bold text-3xl lg:text-4xl text-digtek-header/70 hover:text-digtek-purple transition-colors shrink-0 tracking-tight"
                            >
                                {l}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
